import { useEffect, useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { NAV_LINKS, SCHOOL_NAME } from "../data/siteData";
import "./NavBar.css";

const linkClass = ({ isActive }) =>
  `navbar__link${isActive ? " is-active" : ""}`;

export default function NavBar() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const close = () => setOpen(false);

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  useEffect(() => {
    if (!open) return undefined;

    const onKeyDown = (e) => {
      if (e.key === "Escape") {
        setOpen(false);
      }
    };

    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", onKeyDown);

    return () => {
      document.body.style.overflow = "";
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [open]);

  /* ---------- Features scroll ---------- */

  const handleFeaturesClick = (e) => {
    e.preventDefault();
    close();

    if (pathname === "/") {
      const section = document.getElementById("Features");

      if (section) {
        section.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }

      return;
    }

    navigate("/");

    setTimeout(() => {
      const section = document.getElementById("Features");

      if (section) {
        section.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }, 300);
  };

  const links = NAV_LINKS.map(({ label, to }) => {
    if (label === "Features") {
      return (
        <a
          key="features"
          href="#Features"
          className="navbar__link"
          onClick={handleFeaturesClick}
        >
          Features
        </a>
      );
    }

    return (
      <NavLink
        key={to}
        to={to}
        end={to === "/"}
        className={linkClass}
        onClick={close}
      >
        {label}
      </NavLink>
    );
  });

  return (
    <>
      <header className="navbar">
        <Link
          to="/"
          className="navbar__brand"
          aria-label={`${SCHOOL_NAME} – home`}
        >
          <img src="/images/logo.png" alt={SCHOOL_NAME} />
        </Link>

        <nav className="navbar__links" aria-label="Main navigation">
          {links}
        </nav>

        <Link to="/Admission" className="btn navbar__cta">
          Enquire now
        </Link>

        <button
          type="button"
          className="navbar__toggle"
          aria-label="Open menu"
          aria-expanded={open}
          aria-controls="mobile-menu"
          onClick={() => setOpen(true)}
        >
          <span />
          <span />
          <span />
        </button>
      </header>

      <div
        className={`drawer-backdrop${open ? " is-open" : ""}`}
        onClick={close}
        aria-hidden="true"
      />

      <aside
        id="mobile-menu"
        className={`drawer${open ? " is-open" : ""}`}
        aria-label="Mobile menu"
      >
        <button
          type="button"
          className="drawer__close"
          aria-label="Close menu"
          onClick={close}
        >
          &times;
        </button>

        <img
          className="drawer__logo"
          src="/images/logo.png"
          alt={SCHOOL_NAME}
        />

        <nav className="drawer__links" aria-label="Mobile navigation">
          {links}
        </nav>

        <Link
          to="/Admission"
          className="btn drawer__cta"
          onClick={close}
        >
          Enquire now
        </Link>
      </aside>
    </>
  );
}